import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahsyllabus',
  templateUrl: './asahsyllabus.component.html',
  styleUrls: ['./asahsyllabus.component.scss']
})
export class AsahsyllabusComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
